import BuildablePlanBrochureLead from '../models/buildablePlanBrochureLead';
import BuildablePlanInformationLead from '../models/buildablePlanInformationLead';
import CommunityInformationLeadBasic from '../models/communityInformationLeadBasic';
import CommunityBrochureLead from '../models/communityBrochureLead';
import CommunityInformationLead from '../models/communityInformationLead';
import CommunityTourLead from '../models/communityTourLead';
import PlanBrochureLead from '../models/planBrochureLead';
import PlanInformationLead from '../models/planInformationLead';
import PlanInformationLeadBasic from '../models/planInformationLeadBasic';
import PlanTourLead from '../models/planTourLead';
import RecommendedBrochureLead from '../models/recommendedBrochureLead';
import SpecBrochureLead from '../models/specBrochureLead';
import SpecInformationLead from '../models/specInformationLead';
import SpecInformationLeadBasic from '../models/specInformationLeadBasic';
import SpecTourLead from '../models/specTourLead';
import BasicListingInformationLeadBasic from '../models/basicListingInformationLeadBasic';

const leadConstructor = new Map();

leadConstructor.set('buildeablePlan-brochure', BuildablePlanBrochureLead);
leadConstructor.set('community-brochure', CommunityBrochureLead);
leadConstructor.set('plan-brochure', PlanBrochureLead);
leadConstructor.set('spec-brochure', SpecBrochureLead);
leadConstructor.set('recommended', RecommendedBrochureLead);
leadConstructor.set('buildeablePlan-information', BuildablePlanInformationLead);
leadConstructor.set('community-information', CommunityInformationLead);
leadConstructor.set('plan-information', PlanInformationLead);
leadConstructor.set('spec-information', SpecInformationLead);
leadConstructor.set('community-tour', CommunityTourLead);
leadConstructor.set('plan-tour', PlanTourLead);
leadConstructor.set('spec-tour', SpecTourLead);
leadConstructor.set('plan-information-basic', PlanInformationLeadBasic);
leadConstructor.set('spec-information-basic', SpecInformationLeadBasic);
leadConstructor.set('community-information-basic', CommunityInformationLeadBasic);
leadConstructor.set('basicListing-information-basic', BasicListingInformationLeadBasic);


/**
 * Returns the class constructor to create a lead generator.
 *
 * @param data - The information to build the lead for the housing product or service.
 */
export default (data) => {
  const generator = leadConstructor.get(data.type);

  if (!generator) {
    return null;
  }

  return new generator.prototype.constructor(data);
};
